import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonHelper } from '@app/@core/helpers';
import { UsersService } from '@app/@services';
import { MenuItemModel } from '@app/@shared/models/menu.model';
import { UserPrefrencesModel } from '@app/@shared/models/users.model';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header-menu-item',
  templateUrl: './header-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMenuItemComponent implements OnInit, OnDestroy {
  @Input() item: MenuItemModel;
  userPreferences: UserPrefrencesModel;
  unSubscribe$: Subject<any> = new Subject();

  constructor(private userService: UsersService, public readonly transloco: TranslocoService, private readonly commonHelper: CommonHelper) { }

  ngOnInit(): void { }

  /**
   * Header menü de özel durumlar için bu methodu kullanıyoruz.
   * @param item
   */
  onEvent(item: MenuItemModel): void {

    // özel durumlar için böyle bi yöntem kullanıyoruz.
    switch (item.event.type) {

      // varsayılan ana sayfa seçimlerini kullanıcı tercihlerine set ediyoruz.
      case 'homeSelection':
        this.userPreferences = { pageID: 0, pref: item.event.value };
        this.userService.setUserPreferences(this.userPreferences).pipe(takeUntil(this.unSubscribe$)).subscribe((res: any) => {
          // seçili ana sayfaya yönlendirme yapıyoruz.
          this.commonHelper.homePageRedirect(res ? item.event.value : -1);
        });
        break;
    }
  }

  /**
   * aboneliklerden çık
   */
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
